import type { AccountingConnection } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

type Props = {
  connection: AccountingConnection;
};

// Rutter platform slugs come back upper-cased ("QUICKBOOKS", "XERO"). Title-
// case them for display so the card doesn't shout at the user.
function platformLabel(platform: string): string {
  if (!platform) return "Accounting";
  return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
}

export function createConnectQuickbooksCompleted(
  props: Props & { id?: string },
): SmbActionDefinition {
  const { connection, id = `connect-quickbooks:done:${connection.id}` } = props;
  const label = platformLabel(connection.platform);
  return {
    id,
    category: "budget",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="budget"
        badge="Budget"
        title={`${label} connected`}
        details={{
          title: "Accounting connected",
          children: (
            <div className="flex flex-col gap-2">
              <p className="font-medium">{label}</p>
              <p className="opacity-70">
                We're syncing revenue and expense history so we can verify your numbers
                automatically.
              </p>
            </div>
          ),
        }}
      />
    ),
  };
}
